/**
 * 앱 라우팅 진입점
 *
 * /owner — 지점주 (Master): 지점·과제등록·공지
 * /teacher — 강사/지점장: 학생·학급·학습관리·상담
 *
 * Owner/Teacher 레이아웃 컴포넌트가 Header + Outlet을 제공함
 */
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'app/App.css';
import Login from 'pages/auth/Login';
import Owner from 'pages/owner/Owner';
import Teacher from 'pages/teacher/Teacher';
import Home from 'pages/owner/Home';
import TeacherHome from 'pages/teacher/Home';
import Branch from 'pages/owner/Branch';
import Notice from 'pages/owner/Notice';
import BranchRegister from 'features/owner/components/branch/BranchRegister';
import Account from 'pages/teacher/Account';
import AccountRegister from 'features/teacher/components/account/AccountRegister';
import Student from 'pages/teacher/Student';
import StudentRegister from 'features/teacher/components/student/StudentRegister';
import Lesson from 'pages/teacher/Lesson';
import LessonRegister from 'features/teacher/components/lesson/LessonRegister';
import ViewLesson from 'features/teacher/components/lesson/ViewLesson';
import ViewStudent from 'features/teacher/components/lesson/ViewStudent';
import LessonAssignManage from 'features/teacher/components/lesson/LessonAssignManage';
import Counsel from 'pages/teacher/Counsel';
import CounselRegister from 'features/teacher/components/counsel/CounselRegister';
import StudentProfileMain from 'features/teacher/components/student/StudentProfileMain';
import StudentProfile from 'features/teacher/components/student/StudentProfile';
import StudentCounselManage from 'features/teacher/components/student/StudentCounselManage';
import StudentActivity from 'features/teacher/components/student/StudentActivity';
import Report from 'pages/owner/Report';
import Homework from 'pages/teacher/Homework';
import TeacherNotice from 'pages/teacher/TeacherNotice';
import PrivacyPolicy from 'pages/auth/PrivacyPolicy';
import QnA from 'pages/auth/QnA';
import Stats from 'pages/owner/Stats';
import TeacherStats from 'pages/teacher/Stats';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
          <Route path='/privacy' element={<PrivacyPolicy/>}/>
          <Route path='/qna' element={<QnA/>}/>
          <Route path='/' element={<Login/>}/>
          {/* 지점주 영역 */}
          <Route path='owner' element={<Owner/>}>
            <Route path="home" element={<Home />}/>
            <Route path="branch" element={<Branch />}>
              <Route path="register" element={<BranchRegister />}/>
            </Route>
            <Route path='report' element={<Report />}/>
            <Route path="notice" element={<Notice />}/>
            <Route path="stats" element={<Stats />}/>
          </Route>
          {/* 강사/지점장 영역 — report 경로는 Homework(학습관리) 컴포넌트 */}
          <Route path='teacher' element={<Teacher/>}>
            <Route path='notice' element={<TeacherNotice />}/>
            <Route path="home" element={<TeacherHome />}/>
            <Route path="stats" element={<TeacherStats />}/>
            <Route path='report' element={<Homework />}/>
            <Route path='account' element={<Account />}>
              <Route path='register' element={<AccountRegister/>}/>
            </Route>
            <Route path='student' element={<Student />}>
              <Route path='register' element={<StudentRegister/>}/>
            </Route>
            <Route path='lesson' element={<Lesson />}>
              <Route path='view/lesson' element={<ViewLesson />}/>
              <Route path='view/student' element={<ViewStudent/>}/>
              <Route path='manage' element={<LessonAssignManage />}>
                <Route path='register' element={<LessonRegister />}/>
              </Route>
            </Route>
            <Route path='counsel' element={<Counsel/>}>
              <Route path='register' element={<CounselRegister />}/>
            </Route>
            <Route path='student/profile' element={<StudentProfile/>}>
              <Route path='main' element={<StudentProfileMain/>}/>
              <Route path='counsel' element={<StudentCounselManage/>}/>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
